import { CORE_LINK_TRACK_VARS } from "../linkTrackVars"
import type { AnalyticsPage } from "../trackPageView/trackPageView"
import { waitForAppMeasurement } from "../waitForAppMeasurement"

export type AnalyticsEventCategory =
	| AnalyticsPage
	| "add_vehicle"
	| "dealer_feedback"
	| "dealership_list"
	| "delivered_vehicles_action_menu"
	| "delivered_vehicles_classification"
	| "delivered_vehicles_customer_type"
	| "delivered_vehicles_designation"
	| "delivered_vehicles_model_series"
	| "delivered_vehicles_time"
	| "inventory_accident_free"
	| "inventory_action_menu"
	| "inventory_body_design"
	| "inventory_derivatives"
	| "inventory_drive_trains"
	| "inventory_engine_power_unit"
	| "inventory_engine_types"
	| "inventory_equipment"
	| "inventory_exterior_color"
	| "inventory_interior_color"
	| "inventory_listing_quality"
	| "inventory_location"
	| "inventory_min_engine_power"
	| "inventory_max_mileage"
	| "inventory_max_model_year"
	| "inventory_min_model_year"
	| "inventory_max_price"
	| "inventory_model_generations"
	| "inventory_model_series"
	| "inventory_online_orderable"
	| "inventory_previous_owners"
	| "inventory_porsche_approved"
	| "inventory_sales_status"
	| "inventory_status"
	| "inventory_transmissions"
	| "inventory_vat_deductible"
	| "inventory_vehicle_type"
	| "inventory_visibility"
	| "inventory_max_first_registration_date"
	| "inventory_min_first_registration_date"
	| "inventory_vehicle_sharing_bar"
	| "notification_center_popover"
	| "notification_settings"
	| "outlink"
	| "syp-purchase-request-overview"
	| "syp-vehicle-details"
	| "whats_new_modal"
	| "vehicle_details_action_menu"
	| "vehicle_information_pcss"
	| "offer"

export interface TrackEventProps {
	action: string
	category: AnalyticsEventCategory
	clickElementDetails?: string
	name?: string
	value?: number
}

export const trackEvent = ({ action, category, clickElementDetails, name, value }: TrackEventProps) => {
	waitForAppMeasurement((s) => {
		// specify props and vars to be sent with the event tracking call
		// https://experienceleague.adobe.com/en/docs/analytics/implementation/vars/config-vars/linktrackvars
		s.linkTrackVars = `${CORE_LINK_TRACK_VARS},prop7,prop8,prop9,prop10,eVar28,eVar29,eVar30`

		s.prop7 = clickElementDetails
		s.prop8 = action
		s.prop9 = category
		s.prop10 = "button"

		s.eVar28 = action
		s.eVar29 = category
		s.eVar30 = "button"

		// https://experienceleague.adobe.com/en/docs/analytics/implementation/vars/functions/tl-method#stl-method-in-appmeasurement-and-the-analytics-extension-custom-code-editor
		s.tl(
			this,
			category === "outlink" ? "e" : "o", // o = custom link, d = download link, e = exit link
			[category, action, name, value].filter((val) => val !== undefined).join(" "),
		)

		// as values are sticky, we need to reset them afterward
		s.linkTrackVars = ""
		s.prop7 = undefined
		s.prop8 = undefined
		s.prop9 = undefined
		s.prop10 = undefined

		s.eVar28 = undefined
		s.eVar29 = undefined
		s.eVar30 = undefined
	})
}
